import {
    APICommonFilter,
    API_RESULTS,
    PaginationFilter
} from "../dtos/common";
import {
    DINGTALK_APPLY_STATUS,
    DINGTALK_APP_ROLES,
    DINGTALK_AUTH_STATUS
} from "../dtos/userInfo";
import {
    DingtalkAdmins,
    DingtalkApplyUserList,
    DingtalkAutoAuth,
    DingtalkAutoAuthStatus,
    DingtalkUserList,
    DingtalkUserListFilter,
    DingtalkUserRoleFilter
} from "../dtos/userList";
import { DingtalkUserStatistics } from "../dtos/userStatistics";
import DingtalkAPI from "./base";

export default class DingtalkManagementAPI extends DingtalkAPI {
    static getUserStatistics() {
        return this.axios.get(`${this.uri}/ding-talk/user-statistics`, {
            params: this.baseQuery()
        }) as any as API_RESULTS<DingtalkUserStatistics>;
    }

    static getUserList(filters: DingtalkUserListFilter) {
        const params: DingtalkUserListFilter & APICommonFilter = Object.assign(this.baseQuery(), filters);
        return this.axios.get(`${this.uri}/ding-talk/user-list`, {
            params
        }) as any as API_RESULTS<DingtalkUserList>
    }

    static getAdmins() {
        return this.axios.get(`${this.uri}/ding-talk/admin-user-list`, {
            params: this.baseQuery()
        }) as any as API_RESULTS<DingtalkAdmins>;
    }

    /** Requirements changed
     * @deprecated
     */
    static switchAutoAuth(status: DingtalkAutoAuthStatus) {
        return this.axios.put(`${this.uri}/ding-talk/corp`, {
            auto_authed_status: status
        }, {
            params: this.baseQuery()
        }) as any as API_RESULTS<[]>;
    }

    /** Requirements changed
     * @deprecated
     */
    static getSwitchAutoAuth() {
        return this.axios.get(`${this.uri}/ding-talk/corp`, {
            params: this.baseQuery()
        }) as any as API_RESULTS<DingtalkAutoAuth>;
    }

    static changeUserRoleOrAuth(data: DingtalkUserRoleFilter) {
        return this.axios.put(`${this.uri}/ding-talk/user`, data, {
            params: this.baseQuery()
        }) as any as API_RESULTS<[]>;
    }

    static addSubAdmin(userId: string) {
        return this.changeUserRoleOrAuth({
            user_id: userId,
            app_role: DINGTALK_APP_ROLES.SUB_ADMIN
        });
    }

    static deleteSubAdmin(userId: string) {
        return this.changeUserRoleOrAuth({
            user_id: userId,
            app_role: DINGTALK_APP_ROLES.PLAIN
        });
    }

    static changeUserAuthStatus(userId: string, status: DINGTALK_AUTH_STATUS) {
        return this.changeUserRoleOrAuth({
            user_id: userId,
            app_authed_status: status
        });
    }

    static changeUserAuthStatusBatch(userIds: string[], status: DINGTALK_AUTH_STATUS) {
        return this.axios.put(`${this.uri}/ding-talk/user-batch`, {
            user_ids: userIds,
            app_authed_status: status
        }, {
            params: this.baseQuery()
        }) as any as API_RESULTS<[]>;
    }

    static getApplyList({ currentPage = 1, perPage = 10 }: PaginationFilter = {}) {
        const params = Object.assign(this.baseQuery(), {
            status: DINGTALK_APPLY_STATUS.PENDING,
            currentPage,
            perPage
        });
        return this.axios.get(`${this.uri}/apply/list`, {
            params
        }) as any as API_RESULTS<DingtalkApplyUserList>
    }

    static submitApplication() {
        return this.axios.post(`${this.uri}/apply`, null, {
            params: this.baseQuery()
        }) as any as API_RESULTS<[]>;
    }

    static dealWithApplication(id: string, status: DINGTALK_APPLY_STATUS) {
        return this.axios.put(`${this.uri}/apply`, {
            id,
            status
        }, {
            params: this.baseQuery(),
        }) as any as API_RESULTS<[]>;
    }

    static sendUrge(applyId: number) {
        return this.axios.post(`${this.uri}/apply/urge`, {
            apply_id: applyId
        }, {
            params: this.baseQuery()
        }) as any as API_RESULTS<[]>;
    }

}
